import type { ImageType } from '@app-types/image'
import { ContentfulImage } from '@components/contentful-image'
import { Skeleton } from '@components/skeleton'
import type { FunctionComponent, ReactNode } from 'react'
import { isValidElement } from 'react'

import styles from './article-cover.module.scss'

/**
 * Article cover image or any JSX element.
 */
export const ArticleCover: FunctionComponent<ArticleCoverProps> = ({
    element,
    loading,
    image,
}) => {
    if (loading) {
        return <Skeleton className={styles.skeleton} width='100%' />
    }

    if (isValidElement(element)) {
        return <div className={styles.container}>{element}</div>
    }

    if (!image) return null

    return (
        <div className={styles.container}>
            <ContentfulImage
                url={image.source}
                alt={image.alt}
                contentType={image.contentType}
                sizes='100vw'
                priority
                className={styles.image}
                style={{ objectFit: 'contain', width: '100%', height: 'auto' }}
            />
        </div>
    )
}

export type ArticleCoverProps = {
    element?: ReactNode
    image?: ImageType
    loading?: boolean
}
